<template>
  <div id="app">
    <div class="main-wrapper">
      <router-view />
    </div>
  </div>
</template>
<script>
import http from "@/utils/http";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.getRolePermissions();
    this.fetchNotifications();
  },
  watch: {
    $route() {
      this.fetchNotifications();
    }
  },
  methods: {
    async getRolePermissions() {
      try {
        const response = await http.get("get-role-permissions");

        if (response.data.contents.permissions) {
          this.$store.commit("setUser", response.data.contents?.user);
          this.$store.commit("setUserRoles", response.data.contents.roles);
          this.$store.commit(
            "setUserPermissions",
            response.data.contents.permissions
          );
        }
      } catch (error) {
        // console.error("Error:", error);
      } finally {
        // this.isLoading = false;
      }
    },
    async fetchNotifications() {
      const endpoint = `/all-leads-edit-requests`;
      const method = "get";
      try {
          const response = await http[method](endpoint);
          this.$store.commit('setSupervisorNotifications', response.data.contents);
      } catch (error) {
          console.error("Error fetching employees:", error);
      }
    },
  },
};
</script>
